import { render, staticRenderFns } from "./layTableTotal.vue?vue&type=template&id=66db9c03&scoped=true"
import script from "./layTableTotal.vue?vue&type=script&lang=js"
export * from "./layTableTotal.vue?vue&type=script&lang=js"
import style0 from "./layTableTotal.vue?vue&type=style&index=0&id=66db9c03&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66db9c03",
  null
  
)

export default component.exports